import {
  TableHead,
  TableHeader,
  TableRow,
  DefinitionTooltip,
} from '@carbon/react';
import { Link } from 'components/link';
import { Checkmark } from '@carbon/react/icons';
import styles from '../allocation-manager.module.scss';
import { AllocationManagerTableHeadersProps } from 'pages/development-areas/show/allocation-manager-types';
import React from 'react';

const HeaderContent = ({
  children,
  isActive,
  headerType,
}: {
  children: React.ReactNode;
  isActive: boolean;
  headerType: 'acreage' | 'lateral_length';
}) => {
  return (
    <div
      className={styles.clickableHeaderContent}
      data-testid={`${headerType}-header`}
    >
      {children}
      {isActive && (
        <span className={styles.checkmarkCircle}>
          {headerType === 'acreage' ? (
            <DefinitionTooltip
              definition="NRI calculations in the Ownership panel are based on Acreage Allocation Method."
              align="top"
              className={styles.tooltipWrapper}
              openOnHover
            >
              <Checkmark className={styles.checkmarkIcon} />
            </DefinitionTooltip>
          ) : (
            <DefinitionTooltip
              definition="NRI calculations in the Ownership panel are based on Lateral Length Allocation Method."
              align="top"
              className={styles.tooltipWrapper}
              openOnHover
            >
              <Checkmark className={styles.checkmarkIcon} />
            </DefinitionTooltip>
          )}
        </span>
      )}
    </div>
  );
};

export const AllocationManagerTableHeaders = ({
  renderLateralLengthValues,
  uwi,
  activeHeader = 'acreage',
}: AllocationManagerTableHeadersProps) => {
  return (
    <TableHead>
      <TableRow>
        <TableHeader className={styles.mainHeader}>
          Well:{' '}
          <Link target="_blank" to={`/wells/${uwi}`}>
            {uwi}
          </Link>
        </TableHeader>
        <TableHeader
          colSpan={3}
          className={`${styles.mainHeader} ${styles.acreageHeader} ${
            !renderLateralLengthValues || activeHeader === 'acreage'
              ? styles.activeHeader
              : styles.inactiveHeader
          }`}
          data-testid="acreage-allocation-header"
        >
          <HeaderContent
            headerType="acreage"
            isActive={!renderLateralLengthValues || activeHeader === 'acreage'}
          >
            Acreage Allocation
          </HeaderContent>
        </TableHeader>
        <TableHeader
          colSpan={3}
          className={`${styles.mainHeader} ${styles.lateralHeader} ${
            activeHeader === 'lateral_length' && renderLateralLengthValues
              ? styles.activeHeader
              : styles.inactiveHeader
          }`}
          data-testid="lateral-allocation-header"
        >
          <HeaderContent
            headerType="lateral_length"
            isActive={
              activeHeader === 'lateral_length' && renderLateralLengthValues
            }
          >
            Lateral Length Allocation
          </HeaderContent>
        </TableHeader>
      </TableRow>
      <TableRow className={styles.subHeaderRow}>
        <TableHeader className={styles.subHeader}>
          Unit Allocation Tracts
        </TableHeader>
        <TableHeader className={`${styles.subHeader} ${styles.acreageHeader}`}>
          Value (ac)
        </TableHeader>
        <TableHeader className={`${styles.subHeader} ${styles.acreageHeader}`}>
          Factor (%)
        </TableHeader>
        <TableHeader className={`${styles.subHeader} ${styles.acreageHeader}`}>
          GIS Calc Value (ac)
        </TableHeader>
        {renderLateralLengthValues ? (
          <>
            <TableHeader
              className={`${styles.subHeader} ${styles.lateralHeader}`}
            >
              Value (ft)
            </TableHeader>
            <TableHeader
              className={`${styles.subHeader} ${styles.lateralHeader}`}
            >
              Factor (%)
            </TableHeader>
            <TableHeader
              className={`${styles.subHeader} ${styles.lateralHeader}`}
            >
              GIS Calc Value (ft)
            </TableHeader>
          </>
        ) : (
          <TableHeader
            colSpan={3}
            className={`${styles.subHeader} ${styles.lateralHeader}`}
          />
        )}
      </TableRow>
    </TableHead>
  );
};
